import Session from 'apis/sdk'
import Accounts from 'apis/sdk/accounts'
import cookie from 'react-cookies';
import {
  LOGIN_USER,
  AUTHENTICATE_USER,
  REFRESH_USERDATA,
  REFRESH_MEMBERDATA,
  USER_ACCOUNTS,
  NEW_ACTIVE_NETWORK,
  USER_REHYDRATE_ANALYTICS,
  USER_COMPARE_ANALYTICS,
  USER_RESET_ANALYTICS,
  SET_FORM_DEFAULTS,
  UPDATE_DASHBOARD,
  UPDATE_MEDIA,
  ACTIVE_NETWORK,
  ACTIVE_DASHBOARD,
  UPDATE_ACCOUNTS
} from '../constants';

const INIT_STATE = {
  status:false,
  user:false,
  ui:{},
  forms:{},
  configuration:false,
  accounts:{},
  memberAccounts:{},
  activeNetwork:false,
  activeDashboard:{},
  reports:{},
  views:{},
  media:[]
};
export default (state = INIT_STATE, action) => {
  var stateRefresh = (action.payload) ? action.payload : action;
  
  switch (action.type) {
    case SET_FORM_DEFAULTS:
      return {
        ...state,
        forms:{...stateRefresh}
      }
      break;
    case AUTHENTICATE_USER:
      stateRefresh.session.userRoles = (stateRefresh.session.userRoles) ? stateRefresh.session.userRoles : (state.status.userRoles) ? state.status.userRoles : false;
      return {
        ...state,
        status:{...state.status,...stateRefresh.session},
        configuration:{...state.configuration,...stateRefresh.configuration},
      }
      case LOGIN_USER:
        return {
          ...state,
          status:stateRefresh.session,
          user:stateRefresh.user,
          ui:stateRefresh.ui,
          configuration:{...state.configuration,...stateRefresh.configuration},
          accounts:{...state.accounts,...stateRefresh.accounts,...stateRefresh.views},
          forms:{...state.forms,...stateRefresh.forms}
        }
        break;
        case USER_ACCOUNTS:
          return {
            ...state,
            accounts:{...state.accounts,...{User:stateRefresh.accounts.User}}
          }
          break;
        case UPDATE_ACCOUNTS:
          var acs = {...state.accounts};
          for (var o of Object.keys(stateRefresh.accounts)){
            acs[o] = stateRefresh.accounts[o];
          }
          return {
            ...state,
            accounts:acs
          }
          break;
      case USER_REHYDRATE_ANALYTICS:
        var _srp = state.reports;
        stateRefresh.analytics = (stateRefresh.analytics) ? stateRefresh.analytics : {};
        Object.keys(stateRefresh.analytics).map((sp) => {
        _srp[sp] = (state.reports[sp]) ? state.reports[sp] : stateRefresh.analytics[sp];
          Object.keys(stateRefresh.analytics[sp]).map((ssp) => {
                _srp[sp][ssp] = (state.reports[sp][ssp]) ? state.reports[sp][ssp] : stateRefresh.analytics[sp][ssp];
           })
        
          
        })
        return {
          ...state,
          reports:_srp
        }
        break;
        
        case USER_COMPARE_ANALYTICS:
          var _srp = state.reports;
          stateRefresh.analytics = (stateRefresh.analytics) ? stateRefresh.analytics : {};
          Object.keys(stateRefresh.analytics).map((sp) => {
          _srp[sp] = (state.reports[sp]) ? state.reports[sp] : {};
            Object.keys(stateRefresh.analytics[sp]).map((ssp) => {
              _srp[sp][ssp] = (state.reports[sp][ssp]) ? state.reports[sp][ssp] : {};
              _srp[sp][ssp].compare = (_srp[sp][ssp].compare) ? _srp[sp][ssp].compare : stateRefresh.analytics[sp][ssp];
             })
          
            
          })
          return {
            ...state,
            reports:_srp
          }
          break;

      case USER_RESET_ANALYTICS:
          return {
            ...state,
            reports:{}
          }
      case NEW_ACTIVE_NETWORK:
        console.log(stateRefresh,action.payload);
        return {
          ...state,
        activeNetwork:action.payload
        }
        break;
      case ACTIVE_NETWORK:
        var cid = (stateRefresh && stateRefresh.clickId) ? stateRefresh.clickId : (action.payload.clickId) ? action.payload.clickId : 0;
        return {
          ...state,
          activeNetwork:(state.accounts.Network) ? state.accounts.Network.map((n) => {return (n.id == stateRefresh.clickId) ? n : false}).filter(a=>a).pop() : false,
        }
        break;
      case ACTIVE_DASHBOARD:
        return {
          ...state,
          activeDashboard:(state.activeNetwork && state.activeNetwork.Dashboard) ? state.activeNetwork.Dashboard.map((n) => {return (n.id == stateRefresh.clickId) ? n : false}).filter(a=>a).pop() : false,
        }
        break;
      case REFRESH_USERDATA:
        var accounts = {...state.accounts};
        return {
          ...state,
          accounts:{...state.accounts,...stateRefresh.accounts},
          activeNetwork:{...state.activeNetwork,...stateRefresh.activeNetwork}

        }
        break;
        case REFRESH_MEMBERDATA:
          var accounts = {...state.accounts};
          return {
            ...state,
            memberAccounts:{...state.memberAccounts,...stateRefresh.accounts},
  
          }
          break;
        case UPDATE_DASHBOARD:
          return {
            ...state,
            accounts:{...state.accounts,...stateRefresh.accounts,...stateRefresh.views},
          }
          break;
        case UPDATE_MEDIA:
          return {
            ...state,
            media:stateRefresh.media
          }
          break;
    default:
      return { ...state };
  }
};
